module.exports = __webpack_public_path__ + "img/linkedin-sociocon.8a37c212.png";